module.exports = __webpack_public_path__ + "media/silent-night.0fa19a37.mp3";